export default __webpack_public_path__ + "static/media/colin-portrait-mountain.344e3d29.jpeg";